import React from "react";
import { Table } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import { getFarmerInfoList, doFarmerInfoDelete } from "../../../../redux/farmerinfo/farmerInfoState";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import { handleTableChange, displayFullName, displayAddress } from "../../../../utils/index";
import { API_URL } from '../../../../constants';
import StatusInfo from "views/panel/components/StatusInfo";
import ModuleSearchFilter from "components/search/ModuleSearchFilter";

const FarmerInfoTable = ({ recordList, pagination, doSearch, doDelete, filters }) => {
	const { getColumnSearchProps } = ColumnSearchFilter();
  	const columns = [
		{
	        title: `Name`,
	        dataIndex: 'personal_information',
	        key: 'personal_information',
	        width: '30%',
	        sorter: true,
	        ...getColumnSearchProps('name'),
	        render:(personal_information, record) => <a href={`/console/farmer-informations/${record.id}/view`}>
				{displayFullName(personal_information)}
				</a>
	    },
	    {
	        title: `Address`,
	        dataIndex: 'personal_information',
	        key: 'address',
	        width: '43%',
	        render:(personal_information) => <span>{displayAddress(personal_information?.address)}</span>
	    },
		{
	        title: `Validation Status`,
	        dataIndex: 'certify_status_name',
	        key: 'certify_status_name',
	        width: '15%',
	        render:(certify_status_name) => <StatusInfo className="p-1" status={certify_status_name} />
	    },
	    {
	        title: '',
	        dataIndex: 'id',
	        key: 'id',
	        width: '12%',
	        render:(id) => <CrudOption 
				baseRoute="/console/farmer-informations" 
				recordId={id} 
				deleteHandler={doDelete}
				allowDownload={true}
				downloadLabel="Download RSBSA"
				downloadURL={`${API_URL}/generate-rsbsa/${id}`}
			/>
	    },
    ];
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
				<ModuleSearchFilter 
					placeholder="Search by Farmer's Name"
					searchHandler={doSearch}
					defaultFilters={{paginate: pagination.per_page}}
					filters={filters}
					filterName="farmerList"
					pagination={pagination}
				/>
	      	
	      		<Table
		        	dataSource={recordList}
		        	columns={columns} 
		            rowKey={(record) => record.id}
		        	pagination={{...pagination, 
						current: pagination.current_page,
						showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}
		            onChange={handleTableChange(doSearch, filters, 'farmerList')}  
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.farmerInfo.recordList?.items,
	pagination: state.farmerInfo.recordList?.pagination,
	filters: state.farmerInfo.recordList?.filters,
  	requesting: state.farmerInfo.recordList?.requesting,
  	error: state.farmerInfo.recordList?.error,
  
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getFarmerInfoList(filters)),
  doDelete: (id) => dispatch(doFarmerInfoDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FarmerInfoTable);